<template>
    <v-app>
        <div class="d-flex flex-column flex-root">
            <div
                class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                :class="{
                    'login-signin-on': this.state == 'signin',
                    'login-signup-on': this.state == 'signup',
                    'login-forgot-on': this.state == 'forgot'
                }"
                id="kt_login"
                
            >   
                <!--begin::Aside-->
                
                
                
                <div
                    class="login-aside d-flex flex-column flex-row-auto"
                    :style="{ backgroundImage: `url(${backgroundImage})` }"
                    style="background-color: #0E3765;"
                >
                <div
                        class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
                    ></div>
                </div>
                <!--begin::Aside-->
                <!--begin::Content-->
                <div
                    class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
                >
                    <div class="d-flex flex-column-fluid flex-center">
                        <!--begin::Signin-->
                        <div class="login-form login-signin">
                            <form
                                class="form"
                                novalidate="novalidate"
                                id="kt_login_signin_form"
                            >
                                <div class="pb-13 pt-lg-0 pt-5">
                                    <h3
                                        class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                                    >
                                        KKTCFBD | Üye Takip Uygulaması
                                    </h3>
                                    
                                    
                                    <span
                                        class="text-muted font-weight-bold font-size-h4"
                                        >Bu uygulamayı daha önce kullanmadınız mı?
                                        <a
                                            href="#"
                                            id="kt_login_signup"
                                            class="text-primary font-weight-bolder"
                                            @click="showForm('signup')"
                                            >Kaydolun
                                        </a>
                                    </span
                                    >
                                    
                                </div>
                                <!--
                                <div class="form-group">
                                    
                                    <label
                                        class="font-size-h6 font-weight-bolder text-dark"
                                        >Kullanıcı adı</label
                                    >
                                    <div
                                        id="example-input-group-1"
                                        label=""
                                        label-for="example-input-1"
                                    >
                                        <input
                                            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                                            type="text"
                                            name="username"
                                            ref="username"
                                            v-model="form.username"
                                        />
                                    </div>
                                </div>
                                -->
                                <div class="form-group">
                                    <label
                                        class="font-size-h6 font-weight-bolder text-dark"
                                        >Email</label
                                    >
                                    <div
                                        id="example-input-group-1"
                                        label=""
                                        label-for="example-input-1"
                                    >
                                        <input
                                            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                                            type="text"
                                            name="email"
                                            ref="email"
                                            v-model="form.email"
                                        />
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <div
                                        class="d-flex justify-content-between mt-n5"
                                    >
                                        <label
                                            class="font-size-h6 font-weight-bolder text-dark pt-5"
                                            >Şifre</label
                                        >
                                        <a
                                            href="#"
                                            class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5"
                                            id="kt_login_forgot"
                                            @click="showForm('forgot')"
                                            >Şifrenizi unuttunuz mu ?</a
                                        >
                                    </div>
                                    <div
                                        id="example-input-group-2"
                                        label=""
                                        label-for="example-input-2"
                                    >
                                        <input
                                            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                                            type="password"
                                            name="password"
                                            ref="password"
                                            v-model="form.password"
                                            autocomplete="off"
                                        />
                                    </div>
                                </div>
                                <div class="pb-lg-0 pb-5">
                                    <button
                                        ref="kt_login_signin_submit"
                                        class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                                    >
                                        Giriş
                                    </button>
                                    <!--<button
                                        type="button"
                                        class="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg"
                                    >
                                        <span class="svg-icon svg-icon-md">
                                            <inline-svg
                                                src="media/svg/social-icons/google.svg"
                                            /> </span
                                        >Google ile Giriş
                                    </button>-->
                                </div>
                            </form>
                        </div>
                        <!--end::Signin-->
                        <!--begin::Signup-->
                        
                        
                        <div class="login-form login-signup">
                            <form
                                class="form"
                                novalidate="novalidate"
                                id="kt_login_signup_form"
                            >
                                <div class="pb-13 pt-lg-0 pt-5">
                                    <h3
                                        class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                                    >
                                        Kaydol
                                    </h3>
                                    <p
                                        class="text-muted font-weight-bold font-size-h4"
                                    >
                                        Kişisel bilgilerinizi girip hesabınızı yaratın
                                        </p>
                                </div>
                                <!--<div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="text"
                                        placeholder="Kullanıcı adı"
                                        name="username"
                                        ref="rusername"
                                        autocomplete="off"
                                        v-model="form.username"
                                    />
                                    <div v-if="errors.username" :errors="errors">
                                        <p v-for="error in errors.username" class="mr-1 text-danger" :key="error.username">{{ error }}</p>
                                    </div>
                                </div>
                                -->
                                
                                <div class="form-group">
                                    <v-select
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6" 
                                        v-model="form.is_member_before"
                                        :items="is_member_before"
                                        label="Derneğimize Daha Önceden Üyeliğiniz Var Mı?"
                                        ref="ris_member_before"
                                    ></v-select>
                                    <div v-if="errors.is_member_before" :errors="errors">
                                        <p v-for="error in errors.is_member_before" class="mr-1 text-danger" :key="error.is_member_before">{{ error }}</p>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="text"
                                        placeholder="İsim Soyisim"
                                        name="name"
                                        ref="rname"
                                        autocomplete="off"
                                        v-model="form.name"
                                    />
                                    <div v-if="errors.name" :errors="errors">
                                        <p v-for="error in errors.name" class="mr-1 text-danger" :key="error.name">{{ error }}</p>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="email"
                                        placeholder="Email"
                                        name="email"
                                        ref="remail"
                                        autocomplete="off"
                                        v-model="form.email"
                                    />
                                    <div v-if="errors.email" :errors="errors">
                                        <p v-for="error in errors.email" class="mr-1 text-danger" :key="error.email">{{ error }}</p>
                                    </div>
                                </div>
                                <label class="col-lg-4 col-form-label">Doğum Tarihi:</label>
                                <div class="form-group position-relative">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="date"
                                        name="date_of_birth"
                                        ref="rdate_of_birth"
                                        v-model="form.date_of_birth"
                                        placeholder="Doğum Tarihi"
                                        autocomplete="off"
                                    />

                                <div v-if="errors.date_of_birth" :errors="errors">
                                    <p v-for="error in errors.date_of_birth" class="mr-1 text-danger" :key="error">{{ error }}</p>
                                </div>
                            </div>

                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="text"
                                        placeholder="Doğum Yeri"
                                        name="birth_place"
                                        ref="rbirth_place"
                                        autocomplete="off"
                                        v-model="form.birth_place"
                                    />
                                    <div v-if="errors.birth_place" :errors="errors">
                                        <p v-for="error in errors.birth_place" class="mr-1 text-danger" :key="error.birth_place">{{ error }}</p>
                                    </div>
                                </div>

                                

                                <div class="form-group">
                                    <v-select
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6" 
                                        v-model="form.region" 
                                        :items="regions"
                                        label="İkamet Ettiği Bölge"
                                        ref="rregion"
                                    ></v-select>
                                    <div v-if="errors.region" :errors="errors">
                                        <p v-for="error in errors.region" class="mr-1 text-danger" :key="error.region">{{ error }}</p>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-group">
                                        <!-- Prefix for the phone number (like +90) -->
                                        <div class="input-group-prepend">
                                            <span class="input-group-text font-weight-bold">+90</span>
                                        </div>
                                        
                                        <!-- Phone number input -->
                                        <input
                                            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                            type="text"
                                            placeholder="5488684455 (Cep Telefonu)"
                                            name="mobile_phone"
                                            ref="rmobile_phone"
                                            autocomplete="off"
                                            v-model="form.mobile_phone"
                                            @input="formatPhoneNumber"
                                        />
                                    </div>
                                    <div v-if="errors.mobile_phone" :errors="errors">
                                        <p v-for="error in errors.mobile_phone" class="mr-1 text-danger" :key="error.mobile_phone">{{ error }}</p>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="password"
                                        placeholder="Şifre"
                                        name="password"
                                        ref="rpassword"
                                        autocomplete="off"
                                        v-model="form.password"
                                    />
                                    <div v-if="errors.password" :errors="errors">
                                        <p v-for="error in errors.password" class="mr-1 text-danger" :key="error.password">{{ error }}</p>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="password"
                                        placeholder="Şifre tekrar"
                                        name="password_confirmation"
                                        ref="rpassword_confirmation"
                                        autocomplete="off"
                                    />
                                    <div v-if="errors.password_confirmation" :errors="errors">
                                        <p v-for="error in errors.password_confirmation" class="mr-1 text-danger" :key="error.password_confirmation">{{ error }}</p>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="checkbox mb-0">
                                        <input type="checkbox" name="agree" />
                                        <span class="mr-2"></span>
                                        Kabul ediyorum
                                        <a href="#" class="ml-2"
                                            >Şartlar ve koşullar</a
                                        >.
                                    </label>
                                </div>
                                <div
                                    class="form-group d-flex flex-wrap pb-lg-0 pb-3"
                                >
                                    <button
                                        ref="kt_login_signup_submit"
                                        class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                                        style="width:150px;"
                                    >
                                        Kaydet
                                    </button>
                                    <button
                                        type="button"
                                        id="kt_login_signup_cancel"
                                        class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                                        @click="showForm('signin')"
                                    >
                                        İptal
                                    </button>
                                </div>
                            </form>
                        </div>
                        
                        <!--end::Signup-->
                        <!--begin::Forgot-->
                        <div class="login-form login-forgot">
                            <!--begin::Form-->
                            <form
                                class="form"
                                novalidate="novalidate"
                                id="kt_login_forgot_form"
                                ref="kt_login_forgot_form"
                            >
                                <div class="pb-13 pt-lg-0 pt-5">
                                    <h3
                                        class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                                    >
                                        Şifenizi unuttunuz mu ?
                                    </h3>
                                    <p
                                        class="text-muted font-weight-bold font-size-h4"
                                    >
                                        Email adresinizi girerek şifrenizi sıfırlayabilirsiniz
                                    </p>
                                </div>
                                <div class="form-group">
                                    <input
                                        class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                                        type="email"
                                        placeholder="Email"
                                        name="email"
                                        ref="password_reset_email"
                                        autocomplete="off"
                                    />
                                </div>
                                <div class="form-group d-flex flex-wrap pb-lg-0">
                                    <button
                                        id="kt_login_forgot_submit"
                                        ref="kt_login_forgot_submit"
                                        class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                                        
                                        @click="sendResetLinkEmail()"
                                    >
                                        Gönder
                                    </button>
                                    <button
                                        type="button"
                                        id="kt_login_forgot_cancel"
                                        class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                                        @click="showForm('signin')"
                                    >
                                        Login Ekranına Geri Dön
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!--end::Forgot-->
                    </div>
                    <!--begin::Content footer-->
                    <!--<div
                        class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
                    >
                        <a
                            href="#"
                            class="text-primary font-weight-bolder font-size-h5"
                            >Şartlar</a
                        >
                        <a
                            href="#"
                            class="text-primary ml-10 font-weight-bolder font-size-h5"
                            >Planlar</a
                        >
                        <a
                            href="#"
                            class="text-primary ml-10 font-weight-bolder font-size-h5"
                            >Bize Ulaşın</a
                        >
                    </div>-->
                    <!--end::Content footer-->
                </div>
                <!--end::Content-->
            </div>
            <div data-app v-if="popups.length">
                <v-dialog
                    v-for="popup in popups"
                    :key="popup.id"
                    v-model="popup.dialog"
                    persistent
                    max-width="600"
                    max-height="1200"
                >
                    <v-card class="dark-dialog">
                        <v-card-title class="headline">
                            {{ popup.title }}
                        </v-card-title>
                        <v-card-text>
                            <v-img
                                v-for="document in popup.media"
                                :key="document.id"
                                :src="getLink(document.id, document.file_name)"
                                max-height="600"
                                max-width="1200"
                            />
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="text-danger" text @click="popup.dialog = false">
                                Kapat
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </div>
</v-app>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import Vue from "vue";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import { SEND_RESET_LINK } from "@/core/services/store/password_reset.module";


import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER} from "@/core/services/store/auth.module";
import { GET_ALL_POPUPS } from "@/core/services/store/popups.module";
import Swal from "sweetalert2";
import constants from '@/core/constants/index';

export default {
    name: "login-1",
    data() {
        return {
            state: "signin",
            form: {
                username: "",
                name: "",
                email: "",
                password: "",
                region: "",
                is_member_before: "evet"
            },
            regions: constants.REGIONS,

            is_member_before: [  // Dropdown options
                { text: 'Evet', value: 'evet' },
                { text: 'Hayır', value: 'hayir' }
            ],
            dialog: false,
            popups: []
        };
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(["currentUser"]),

        backgroundImage() {
            return (
                process.env.BASE_URL +
                "media/svg/illustrations/logo_fb_2.png"
            );
        },
    },
    mounted() {
        this.dialog = true;
        this.showDialog();
        const signin_form = KTUtil.getById("kt_login_signin_form");
        const signup_form = KTUtil.getById("kt_login_signup_form");
        const forgot_form = KTUtil.getById("kt_login_forgot_form");
        
        this.fv = formValidation(signin_form, {
            fields: {
                username: {
                    validators: {
                        notEmpty: {
                            message: "Kullanıcı adı gerekli"
                        }
                    }
                },
                /*email: {
                    validators: {
                        notEmpty: {
                            message: "Email is required"
                        }
                    }
                },*/
                password: {
                    validators: {
                        notEmpty: {
                            message: "Şifre gerekli"
                        }
                    }
                }
            },
            plugins: {
                trigger: new Trigger(),
                submitButton: new SubmitButton(),
                bootstrap: new Bootstrap()
            }
        });

        
        this.fv1 = formValidation(signup_form, {
            fields: {
                 /*username: {
                    validators: {
                        notEmpty: {
                            message: "Kullanıcı adı gerekli"
                        }
                    }
                },*/
                is_member_before: {
                    validators: {
                        notEmpty: {
                            message: "Lütfen birini seçiniz"
                        },

                        
                    }
                },
                name: {
                    validators: {
                        notEmpty: {
                            message: "İsim ve soyisim gerekli"
                        },

                        callback: {
                            message: "İsim ve soyisim sadece büyük harf olmalıdır",
                            callback: function(value) {
                                // Check if the value is uppercase
                                return value.value === value.value.toUpperCase();
                            }
                        }
                    }
                },
                email: {
                    validators: {
                        notEmpty: {
                            message: "Email gerekli"
                        },
                        emailAddress: {
                            message: "Geçerli bir mail adresi giriniz"
                        }
                    }
                },
                password: {
                    validators: {
                        notEmpty: {
                            message: "Şifre gerekli"
                        }
                    }
                },
                password_confirmation: {
                    validators: {
                        notEmpty: {
                            message: "Şifre tekrar gerekli"
                        },
                        identical: {
                            compare: function() {
                                return signup_form.querySelector(
                                    '[name="password"]'
                                ).value;
                            },
                            message:
                                "Girdiğiniz şifreler aynı değil."
                        }
                    }
                },
                agree: {
                    validators: {
                        notEmpty: {
                            message: "Şartlar ve koşulları kabul etmeniz gerekiyor."
                        }
                    }
                }
            },
            plugins: {
                trigger: new Trigger(),
                submitButton: new SubmitButton(),
                bootstrap: new Bootstrap()
            }
        });
        
        this.fv2 = formValidation(forgot_form, {
            fields: {
                email: {
                    validators: {
                        notEmpty: {
                            message: "Email gerekli"
                        },
                        emailAddress: {
                            message: "Girdiğinizi email adresi geçerli değil"
                        }
                    }
                }
            },
            plugins: {
                trigger: new Trigger(),
                submitButton: new SubmitButton(),
                bootstrap: new Bootstrap()
            }
        });

        this.fv.on("core.form.valid", () => {
            //var username = this.form.username;
            var email = this.form.email;
            var password = this.form.password;

            this.$store.dispatch(LOGOUT);

            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            // dummy delay
            setTimeout(() => {
                this.$store
                    .dispatch(LOGIN, { email, password })
                    .then(() => {
                        this.$router.push({ name: "my-profile" })

                        })
                    .catch(() => {
                        
                    });

                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 500);
        });

        this.fv.on("core.form.invalid", () => {
            Swal.fire({
                title: "",
                text: "Lütfen bilgileri eksiksiz ve doğru giriniz!",
                icon: "error",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false
            });
        });


        
        
        this.fv1.on("core.form.valid", () => {
            const is_member_before = this.$refs.ris_member_before.value;
            const name = this.$refs.rname.value;
            const email = this.$refs.remail.value;
            const password = this.$refs.rpassword.value;
            const password_confirmation = this.$refs.rpassword_confirmation.value;
            const date_of_birth = this.$refs.rdate_of_birth.value;
            const birth_place = this.$refs.rbirth_place.value;
            const region = this.$refs.rregion.value;
            const mobile_phone = this.$refs.rmobile_phone.value;

            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signup_submit"];
            submitButton.classList.add("spinner", "spinner-light", "spinner-right");

            setTimeout(() => {
                // send register request
                
                this.$store
                .dispatch(REGISTER, {
                   
                        is_member_before,
                        name,
                        email,
                        password,
                        password_confirmation,
                        date_of_birth,
                        birth_place,
                        region,
                        mobile_phone
                    
                })
                .then(() => {
                    this.$router.push({ name: "my-membership" });
                })
                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
                    
            }, 500);
            
        });
    },
    methods: {

        getLink(id, file_name) {
            return Vue.axios.defaults.baseURL+`/../storage/uploads/popups/${id}/${file_name}`
        },

        showDialog() {
            this.$store.dispatch(GET_ALL_POPUPS)
            .then((response) => {
                // Add `dialog` field set to true for each popup
                this.popups = response.data.map(popup => ({
                    ...popup,
                    dialog: true, // Open dialog by default
                }));
            });
        },

        showForm(form) {
            this.state = form;
            var form_name = "kt_login_" + form + "_form";
            KTUtil.animateClass(
                KTUtil.getById(form_name),
                "animate__animated animate__backInUp"
            );
        },

        sendResetLinkEmail(){
            const resetButton = this.$refs["kt_login_forgot_submit"];
            resetButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            const data = { email: this.$refs.password_reset_email.value };
            setTimeout(() => {
                this.$store.dispatch(SEND_RESET_LINK, { data })

                resetButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 2000);
        },

        formatPhoneNumber() {
            let phone = this.form.mobile_phone;

            // Remove non-digit characters
            phone = phone.replace(/\D/g, '');

            // Check if the phone number has the correct length (10 digits for a Turkish phone number)
            if (phone.length === 10) {
                // Format the phone number with country code +90
                phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
            }

            // Update the mobile phone field with the formatted phone number
            this.form.mobile_phone = phone;
        }
    }
};
</script>
<style scoped>
.date-placeholder {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: #999;
    pointer-events: none;
}
</style>